import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { Inscription, Module, TestItem } from '../../interfaces';
import { environment } from 'src/environments/environment';
import { ModuleTestService } from '../services/module-test.service';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-virtual-class-path',
  templateUrl: './virtual-class-path.page.html',
  styleUrls: ['./virtual-class-path.page.scss'],
})
export class VirtualClassPathPage implements OnInit {
  public modules: Module[] = [];
  public plan: Inscription = {} as Inscription;
  private _page = 1;
  private _totalPages = 1;
  public noSubscriptionsMsg = '';
  public loaded = false;
  public loading = true;
  public inscriptionId: string = '';

  constructor(
    private httpSv: HttpService,
    private route: ActivatedRoute,
    private moduleTestSv: ModuleTestService,
    private paramSv: ParamServicesService
  ) {}

  async ngOnInit() {
    const incriptionId = this.route.snapshot.paramMap.get('incription_id');
    console.log('incriptionId :>> ', incriptionId);
    this.inscriptionId = incriptionId;
    const res = await this.httpSv.itemIndex(
      'client/inscription',
      '',
      { id: incriptionId },
      'show'
    );
    console.log('res :>> ', res);

    this.plan = res.data as Inscription;
    this.getModules();
  }

  async getModules() {
    const params = {
      pag: this._page,
      subscriptionId: this.plan?.subscription.id,
      domainId: environment.domainId,
    };
    const res = await this.httpSv.itemIndex('learning', '', params);
    const data = res.data;
    this._totalPages = data.meta.last_page;
    this.modules.push(...data.data);
    if (!this.modules.length) {
      this.noSubscriptionsMsg = 'No hay modulos asignados.';
    }
    this.loaded = true;
    this.loading = false;
    if (!this.paramSv.testImages.length) {
      this.paramSv.emitTestImg$.subscribe(() => this.showSuspension());
    } else {
      this.showSuspension();
    }
  }

  showSuspension() {
    if (this.plan.isSuspended) {
      this.moduleTestSv.showReasonModal(
        {
          reazon: 'suspendedPlan',
        } as TestItem,
        this.inscriptionId
      );
    }
  }

  async loadData(ev: InfiniteScroll) {
    ev.disconnect();
    if (this._page >= this._totalPages) {
      ev.complete();
      return true;
    } else {
      this._page++;
    }
    await this.getModules();
    ev.observe();
  }
}
